import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { api } from '@/api/http';

export const Route = createFileRoute('/admin/roadmap')({ component: AdminRoadmap });

function AdminRoadmap() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState<number>(800);

  const { data: html, isLoading, isError } = useQuery({
    queryKey: ['admin-roadmap-html'],
    queryFn: () => api.get('admin/roadmap.html').text(),
    staleTime: 5 * 60 * 1000,
  });

  // Auto-resize: depois que o iframe carrega, lê a altura real do documento e
  // ajusta o iframe pra crescer com o conteúdo (sem scroll interno). Guard de
  // tolerância evita loop quando o body do iframe tem `min-height: 100vh` —
  // sem guard, cada resize do iframe rebate no scrollHeight e cresce sem parar.
  useEffect(() => {
    const el = iframeRef.current;
    if (!el || !html) return;
    const onLoad = () => {
      try {
        const doc = el.contentDocument;
        if (!doc) return;
        let lastSet = 0;
        const update = () => {
          const h = Math.max(doc.documentElement.scrollHeight, doc.body.scrollHeight, 800);
          if (Math.abs(h - lastSet) < 4) return; // ignora jitter subpixel
          lastSet = h;
          setHeight(h);
        };
        update();
        if ('fonts' in doc) (doc as any).fonts?.ready?.then?.(update).catch(() => {});
        const ro = new (window as any).ResizeObserver(update);
        ro.observe(doc.body);
      } catch { /* cross-origin não deve acontecer pois é srcDoc same-origin */ }
    };
    el.addEventListener('load', onLoad);
    return () => el.removeEventListener('load', onLoad);
  }, [html]);

  if (isLoading) {
    return <div className="p-8 text-slate-500 text-sm">Carregando roadmap...</div>;
  }
  if (isError || !html) {
    return <div className="p-8 text-red-600 text-sm">Não foi possível carregar o roadmap.</div>;
  }

  return (
    <iframe
      ref={iframeRef}
      srcDoc={html}
      title="Roadmap Nosso Ello"
      scrolling="no"
      className="w-full border-0 -m-6 lg:-m-8 block"
      style={{ height: `${height}px` }}
    />
  );
}
